<template>
  <div
    ref="scroll"
    class="c-styled-scroll"
  >
    <slot></slot>
  </div>
</template>
<script>
  import Vue from 'vue';
  import PerfectScrollbar from 'perfect-scrollbar';
  import { TabIndex } from '@/shared/enums';

  const PADDINGS_AND_NAVBAR_HEIGHT = 150;

  export default {
    name: 'StyledScroll',
    props: {
      wheelPropagation: Boolean,
      maxPageHeight: Boolean,
    },
    computed: {
      maxHeight() {
        return document.documentElement.scrollHeight - PADDINGS_AND_NAVBAR_HEIGHT;
      },
    },
    mounted() {
      const container = this.$refs.scroll;

      this.perfectScroll = new PerfectScrollbar(container, {
        wheelPropagation: this.wheelPropagation,
        minScrollbarLength: 30,
      });

      Vue.nextTick(() => {
        this.perfectScroll?.scrollbarY?.setAttribute('tabindex', TabIndex.DISABLED);
        this.perfectScroll?.scrollbarX?.setAttribute('tabindex', TabIndex.DISABLED);

        this.$emit('created', this.perfectScroll);
        this.perfectScroll?.update();
        if (this.maxPageHeight && container) {
          container.style.maxHeight = `${this.maxHeight}px`;
        }
      });
    },
    beforeDestroy() {
      // Hack to clear easingLoop interval which causes infinite error loop
      // https://github.com/mdbootstrap/perfect-scrollbar/issues/835
      this.perfectScroll.isInitialized = true;
      this.perfectScroll.destroy();
      this.perfectScroll = null;
    },
  };
</script>
